import {
  Document,
  PDFViewer,
  Page as PDFPage,
  StyleSheet,
  Text as PDFText,
  View as PDFView,
  Image as PDFImage
} from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    padding: 20
  },
  heading: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 20
  },
  line: {
    height: 0.8,
    backgroundColor: 'black',
    marginVertical: 0
  },
  line2: {
    height: 0.4,
    backgroundColor: 'black',
    marginVertical: 10
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    border: '0.5px solid black'
  },
  column: {
    flex: 1,
    padding: 3
  },
  wideColumn: {
    flex: 2,
    padding: 3
  },
  row: {
    flexDirection: 'row',
    marginBottom: 5
  },
  text: {
    fontSize: 9,
    display: 'inline-block'
  },
  textBold: {
    fontSize: 9,
    fontWeight: 'bold'
  },
  textUnderlined: {
    textDecoration: 'underline'
  },
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    marginTop: 5
  },
  tableRow: {
    flexDirection: 'row'
  },
  tableColHeader: {
    width: '20.28%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    backgroundColor: '#f0f0f0',
    padding: 5
  },
  tableCol: {
    width: '20.28%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    padding: 5
  },
  tableCellHeader: {
    fontSize: 10,
    fontWeight: 'bold'
  },
  tableCell: {
    fontSize: 10
  }
});

const fullScreenStyles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1000,
    backgroundColor: 'white'
  }
};

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

export const IndoorRegisterationPDF = ({ data }) => {
  console.log(data);
  return (
    <div style={fullScreenStyles.container}>
      <PDFViewer width="100%" height="100%" showToolbar>
        <Document title={`Opd Service Invoice`}>
          <Page size="A4" style={styles.page}>
            <PDFImage
              src="/logo_Hospital_m.jpeg"
              style={{ width: '50%', height: '50px', marginBottom: 20, marginLeft: '120px' }}
            />
            <View style={styles.row}>
              <Text content="ADDMISSION REGISTRATION FORM" style={{ fontSize: '9px', margin: '0 auto' }} />
            </View>
            {/* First Row */}
            <View style={styles.contentContainer}>
              <View style={{ ...styles.wideColumn, borderRight: '0.5px solid black' }}>
                <View style={styles.row}>
                  <Text content="Name     : " style={styles.textBold} />
                  <Text content={`${data.name}`} style={styles.textUnderlined} />
                </View>
              </View>

              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}>
                  <Text content="UHID No.             " />
                </View>
              </View>
              <View style={styles.column}>
                <View style={styles.row}>
                  <Text content="IPD No.            " />
                </View>
              </View>
            </View>
            {/* Second Row */}
            <View style={styles.contentContainer}>
              <View style={{ ...styles.wideColumn, borderRight: '0.5px solid black' }}>
                <View style={styles.row}>
                  <Text content="Father's/Husband Name: " style={styles.textBold} />
                  <Text content={`${data.doctorName}`} style={styles.textUnderlined} />
                </View>
              </View>

              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}>
                  <Text content={`${data.dischargeDate}`} style={styles.textUnderlined} />
                </View>
              </View>
              <View style={styles.column}>
                <View style={styles.row}>
                  <Text content={`${data.diagnosis}`} style={styles.textUnderlined} />
                </View>
              </View>
            </View>
            {/*Third Row*/}
            <View style={styles.contentContainer}>
              <View style={{ ...styles.wideColumn, borderRight: '0.5px solid black' }}>
                <View style={styles.row}>
                  <Text content="Address: " style={styles.textBold} />
                  <Text content={`${data.doctorName}`} style={styles.textUnderlined} />
                </View>
              </View>
            </View>

            {/*Third Row*/}
            <View style={styles.contentContainer}>
              <View style={{ ...styles.wideColumn, borderRight: '0.5px solid black' }}>
                <View style={styles.row}>
                  <Text content="Age/Birth : " style={styles.textBold} />
                  <Text content={`${data.doctorName}`} style={styles.textUnderlined} />
                </View>
              </View>
              <View style={{ ...styles.wideColumn, borderRight: '0.5px solid black' }}>
                <View style={styles.row}>
                  <Text content="Admission Date/Time : " style={styles.textBold} />
                  <Text content={`${data.doctorName}`} style={styles.textUnderlined} />
                </View>
              </View>
            </View>
            {/*Fourth Row*/}
            <View style={styles.contentContainer}>
              <View style={{ ...styles.wideColumn, borderRight: '0.5px solid black' }}>
                <View style={styles.row}>
                  <Text content="Sex : " style={styles.textBold} />
                  <Text content={`${data.doctorName}`} style={styles.textUnderlined} />
                </View>
              </View>
              <View style={{ ...styles.wideColumn, borderRight: '0.5px solid black' }}>
                <View style={styles.row}>
                  <Text content="Patient Type : " style={styles.textBold} />
                  <Text content={`${data.doctorName}`} style={styles.textUnderlined} />
                </View>
              </View>
            </View>
            {/*fifth Row*/}
            <View style={styles.contentContainer}>
              <View style={{ ...styles.wideColumn, borderRight: '0.5px solid black' }}>
                <View style={styles.row}>
                  <Text content="Phone No. : " style={styles.textBold} />
                  <Text content={`${data.doctorName}`} style={styles.textUnderlined} />
                </View>
              </View>
              <View style={{ ...styles.wideColumn, borderRight: '0.5px solid black' }}>
                <View style={styles.row}>
                  <Text content="Doctor : " style={styles.textBold} />
                  <Text content={`${data.doctorName}`} style={styles.textUnderlined} />
                </View>
              </View>
            </View>
            {/*Sixth Row*/}
            <View style={styles.contentContainer}>
              <View style={{ ...styles.wideColumn, borderRight: '0.5px solid black' }}>
                <View style={styles.row}>
                  <Text content="Guardian Name/Mobile: " style={styles.textBold} />
                  <Text content={`${data.doctorName}`} style={styles.textUnderlined} />
                </View>
              </View>
              <View style={{ ...styles.wideColumn, borderRight: '0.5px solid black' }}>
                <View style={styles.row}>
                  <Text content="Department : " style={styles.textBold} />
                  <Text content={`${data.doctorName}`} style={styles.textUnderlined} />
                </View>
              </View>
            </View>
            {/*Seventh Row*/}
            <View style={styles.contentContainer}>
              <View style={{ ...styles.wideColumn, borderRight: '0.5px solid black' }}>
                <View style={styles.row}>
                  <Text content="Guardian Relation : " style={styles.textBold} />
                  <Text content={`${data.doctorName}`} style={styles.textUnderlined} />
                </View>
              </View>
              <View style={{ ...styles.wideColumn, borderRight: '0.5px solid black' }}>
                <View style={styles.row}>
                  <Text content="Refer By : " style={styles.textBold} />
                  <Text content={`${data.doctorName}`} style={styles.textUnderlined} />
                </View>
              </View>
            </View>
            {/*eighth Row*/}
            <View style={styles.contentContainer}>
              <View style={{ ...styles.wideColumn, borderRight: '0.5px solid black' }}>
                <View style={styles.row}>
                  <Text content="Sponsor : " style={styles.textBold} />
                  <Text content={`${data.doctorName}`} style={styles.textUnderlined} />
                </View>
              </View>
              <View style={{ ...styles.wideColumn, borderRight: '0.5px solid black' }}>
                <View style={styles.row}>
                  <Text content="Ward : " style={styles.textBold} />
                  <Text content={`${data.doctorName}`} style={styles.textUnderlined} />
                </View>
              </View>
            </View>
            {/*nineth Row*/}
            <View style={styles.contentContainer}>
              <View style={{ ...styles.wideColumn, borderRight: '0.5px solid black' }}>
                <View style={styles.row}>
                  <Text content="MLC/Accidental : " style={styles.textBold} />
                </View>
              </View>
              <View style={{ ...styles.wideColumn, borderRight: '0.5px solid black' }}>
                <View style={styles.row}>
                  <Text content="Room/Bed no. : " style={styles.textBold} />
                  <Text content={`${data.doctorName}`} style={styles.textUnderlined} />
                </View>
              </View>
            </View>
            {/*tenth Row*/}
            <View style={styles.contentContainer}>
              <View style={{ ...styles.wideColumn, borderRight: '0.5px solid black' }}>
                <View style={styles.row}>
                  <Text content="Diagnosis : " style={styles.textBold} />
                </View>
              </View>
              <View style={{ ...styles.wideColumn, borderRight: '0.5px solid black' }}>
                <View style={styles.row}>
                  <Text content="Aadhar No.: " style={styles.textBold} />
                </View>
              </View>
            </View>

            <View style={styles.contentContainer}>
              <View style={{ ...styles.wideColumn, borderRight: '0.5px solid black' }}>
                <View style={styles.row}></View>
              </View>
              <View style={{ flex: 0.5 }}>
                <View style={styles.row}>
                  <Text content="    ICD 10 Codes            " />
                </View>
              </View>
            </View>
            <View style={styles.contentContainer}>
              <View style={{ ...styles.wideColumn, borderRight: '0.5px solid black' }}>
                <View style={styles.row}></View>
              </View>
              <View style={{ flex: 0.5 }}>
                <View style={styles.row}></View>
              </View>
            </View>
            <View style={styles.contentContainer}>
              <View style={{ ...styles.wideColumn, borderRight: '0.5px solid black' }}>
                <View style={styles.row}>
                  <Text content="Other Diagnosis/Complication    : " style={styles.textBold} />
                </View>
              </View>
              <View style={{ flex: 0.5 }}>
                <View style={styles.row}></View>
              </View>
            </View>
            <View style={styles.contentContainer}>
              <View style={{ ...styles.wideColumn, borderRight: '0.5px solid black' }}>
                <View style={styles.row}></View>
              </View>
              <View style={{ flex: 0.5 }}>
                <View style={styles.row}></View>
              </View>
            </View>
            <View style={styles.contentContainer}>
              <View style={{ ...styles.wideColumn, borderRight: '0.5px solid black' }}>
                <View style={styles.row}></View>
              </View>
              <View style={{ flex: 0.5 }}>
                <View style={styles.row}></View>
              </View>
            </View>
            <View style={styles.contentContainer}>
              <View style={{ ...styles.wideColumn, borderRight: '0.5px solid black' }}>
                <View style={styles.row}>
                  <Text content="Procedures: " style={styles.textBold} />
                </View>
              </View>

              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}>
                  <Text content="Procedure Date: " />
                </View>
              </View>
              <View style={styles.column}>
                <View style={styles.row}>
                  <Text content="Procedure Codes: " />
                </View>
              </View>
            </View>
            <View style={styles.contentContainer}>
              <View style={{ ...styles.wideColumn, borderRight: '0.5px solid black' }}>
                <View style={styles.row}></View>
              </View>

              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}></View>
              </View>
              <View style={styles.column}>
                <View style={styles.row}></View>
              </View>
            </View>
            <View style={styles.contentContainer}>
              <View style={{ ...styles.wideColumn, borderRight: '0.5px solid black' }}>
                <View style={styles.row}></View>
              </View>

              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}></View>
              </View>
              <View style={styles.column}>
                <View style={styles.row}></View>
              </View>
            </View>
            <View style={styles.contentContainer}>
              <View style={{ ...styles.wideColumn, borderRight: '0.5px solid black' }}>
                <View style={styles.row}></View>
              </View>

              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}></View>
              </View>
              <View style={styles.column}>
                <View style={styles.row}></View>
              </View>
            </View>
            <View style={styles.contentContainer}>
              <View style={{ ...styles.wideColumn, borderRight: '0.5px solid black' }}>
                <View style={styles.row}></View>
              </View>

              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}></View>
              </View>
              <View style={styles.column}>
                <View style={styles.row}></View>
              </View>
            </View>

            <View style={styles.contentContainer}>
              <View style={{ flex: 2, padding: 3, borderRight: '0.5px solid black' }}>
                <View style={styles.row}>
                  <Text content="Medico Legal Case     " style={styles.textBold} />
                </View>
              </View>

              <View style={{ flex: 2, padding: 3, borderRight: '0.5px solid black' }}>
                <View style={styles.row}>
                  <Text content="Transfer/Discharge" />
                </View>
              </View>
              <View style={{ flex: 2, padding: 3, borderRight: '0.5px solid black' }}>
                <View style={styles.row}>
                  <Text content="Billing Details " style={styles.textBold} />
                </View>
              </View>

              <View style={{ flex: 2, padding: 3, borderRight: '0.5px solid black' }}>
                <View style={styles.row}>
                  <Text content="Patient Handover" />
                </View>
              </View>
            </View>
            <View style={styles.contentContainer}>
              <View style={{ flex: 1.33, padding: 3, borderRight: '0.5px solid black' }}>
                <View style={{ flexDirection: 'row' }}>
                  <Text content="Type Of MLC " style={{ width: '100%', fontSize: 6, color: 'grey' }} />
                </View>
                <View style={{ flexDirection: 'row', marginTop: '5px' }}>
                  <Text content="MLC No. " style={{ width: '100%', fontSize: 6, color: 'grey' }} />
                </View>
                <View style={{ flexDirection: 'row', marginTop: '5px' }}>
                  <Text content="Infromed To(Police Station) " style={{ width: '100%', fontSize: 6 }} />
                </View>
                <View style={{ flexDirection: 'row', marginTop: '5px' }}>
                  <Text content="Info Collected By " style={{ width: '100%', fontSize: 6, color: 'grey' }} />
                </View>
                <View style={{ flexDirection: 'row', marginTop: '5px' }}>
                  <Text content="Date Informed " style={{ width: '100%', fontSize: 6, color: 'grey' }} />
                </View>
                <View style={{ flexDirection: 'row', marginTop: '5px' }}>
                  <Text content="Time Informed " style={{ width: '100%', fontSize: 6 }} />
                </View>
              </View>

              <View style={{ flex: 1.33, padding: 3, borderRight: '0.5px solid black' }}>
                <View style={{ flexDirection: 'row', marginTop: '5px' }}>
                  <Text content="D/C Home " style={{ width: '100%', fontSize: 6, color: 'grey' }} />
                </View>
                <View style={{ flexDirection: 'row', marginTop: '5px' }}>
                  <Text content="LAMA" style={{ width: '100%', fontSize: 6, color: 'grey' }} />
                </View>
                <View style={{ flexDirection: 'row', marginTop: '5px' }}>
                  <Text content="Refer " style={{ width: '100%', fontSize: 6, color: 'grey' }} />
                </View>
                <View style={{ flexDirection: 'row', marginTop: '5px' }}>
                  <Text content="DOPR " style={{ width: '100%', fontSize: 6, color: 'grey' }} />
                </View>
                <View style={{ flexDirection: 'row', marginTop: '5px' }}>
                  <Text content="Transfer To Specify " style={{ width: '100%', fontSize: 6, color: 'grey' }} />
                </View>
                <View style={{ flexDirection: 'row', marginTop: '5px' }}>
                  <Text content="Expired :If Yes " style={{ width: '100%', fontSize: 6, color: 'grey' }} />
                </View>
                <View style={{ flexDirection: 'row', marginTop: '5px' }}>
                  <Text content="Certificate Issue " style={{ width: '100%', fontSize: 6, color: 'grey' }} />
                </View>
                <View style={{ flexDirection: 'row', marginTop: '5px' }}>
                  <Text content="Date " style={{ width: '100%', fontSize: 6, color: 'grey' }} />
                </View>
              </View>
              <View style={{ flex: 1.33, padding: 3, borderRight: '0.5px solid black' }}>
                <View style={{ flexDirection: 'row', marginTop: '5px' }}>
                  <Text content="Bill No. " style={{ width: '100%', fontSize: 6, color: 'grey' }} />
                </View>
                <View style={{ flexDirection: 'row', marginTop: '5px' }}>
                  <Text content="Reciept No." style={{ width: '100%', fontSize: 6, color: 'grey' }} />
                </View>
                <View style={{ flexDirection: 'row', marginTop: '5px' }}>
                  <Text content="MLC No. " style={{ width: '100%', fontSize: 6, color: 'grey' }} />
                </View>
                <View style={{ flexDirection: 'row', marginTop: '5px' }}>
                  <Text content="Remarks " style={{ width: '100%', fontSize: 6, color: 'grey' }} />
                </View>
              </View>

              <View style={{ flex: 1.33, padding: 3, borderRight: '0.5px solid black' }}>
                <View style={{ flexDirection: 'row', marginTop: '5px' }}>
                  <Text content="NOS " style={{ width: '100%', fontSize: 6, color: 'grey' }} />
                </View>
                <View style={{ flexDirection: 'row', marginTop: '5px' }}>
                  <Text content="Discharge Summary" style={{ width: '100%', fontSize: 6, color: 'grey' }} />
                </View>
                <View style={{ flexDirection: 'row', marginTop: '5px' }}>
                  <Text content="X-Ray USG/Films" style={{ width: '100%', fontSize: 6, color: 'grey' }} />
                </View>
                <View style={{ flexDirection: 'row', marginTop: '5px' }}>
                  <Text content="ECG " style={{ width: '100%', fontSize: 6, color: 'grey' }} />
                </View>
                <View style={{ flexDirection: 'row', marginTop: '5px' }}>
                  <Text content="Lab Reports " style={{ width: '100%', fontSize: 6, color: 'grey' }} />
                </View>
                <View style={{ flexDirection: 'row', marginTop: '5px' }}>
                  <Text content="Others " style={{ width: '100%', fontSize: 6, color: 'grey' }} />
                </View>
              </View>
            </View>
          </Page>
        </Document>
      </PDFViewer>
    </div>
  );
};
